/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
    Route,
    RouteFromJSON,
    RouteFromJSONTyped,
    RouteToJSON,
} from './';

/**
 * 
 * @export
 * @interface ShoppingDiagnosticsRequest
 */
export interface ShoppingDiagnosticsRequest {
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof ShoppingDiagnosticsRequest
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof ShoppingDiagnosticsRequest
     */
    channel?: Int32IdAndLabel;
    /**
     * 
     * @type {string}
     * @memberof ShoppingDiagnosticsRequest
     */
    salesJourney?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShoppingDiagnosticsRequest
     */
    agency?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShoppingDiagnosticsRequest
     */
    directFlightsOnly?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShoppingDiagnosticsRequest
     */
    preferredCarriers?: Array<string> | null;
    /**
     * 
     * @type {object}
     * @memberof ShoppingDiagnosticsRequest
     */
    maxConnectionTime?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShoppingDiagnosticsRequest
     */
    excludeBaglessFares?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShoppingDiagnosticsRequest
     */
    fareTypes?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof ShoppingDiagnosticsRequest
     */
    accountCode?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ShoppingDiagnosticsRequest
     */
    passengerAges?: Array<number> | null;
    /**
     * 
     * @type {Array<Route>}
     * @memberof ShoppingDiagnosticsRequest
     */
    routes?: Array<Route> | null;
}

export function ShoppingDiagnosticsRequestFromJSON(json: any): ShoppingDiagnosticsRequest {
    return ShoppingDiagnosticsRequestFromJSONTyped(json, false);
}

export function ShoppingDiagnosticsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShoppingDiagnosticsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'channel': !exists(json, 'channel') ? undefined : Int32IdAndLabelFromJSON(json['channel']),
        'salesJourney': !exists(json, 'salesJourney') ? undefined : json['salesJourney'],
        'agency': !exists(json, 'agency') ? undefined : json['agency'],
        'directFlightsOnly': !exists(json, 'directFlightsOnly') ? undefined : json['directFlightsOnly'],
        'preferredCarriers': !exists(json, 'preferredCarriers') ? undefined : json['preferredCarriers'],
        'maxConnectionTime': !exists(json, 'maxConnectionTime') ? undefined : json['maxConnectionTime'],
        'excludeBaglessFares': !exists(json, 'excludeBaglessFares') ? undefined : json['excludeBaglessFares'],
        'fareTypes': !exists(json, 'fareTypes') ? undefined : json['fareTypes'],
        'accountCode': !exists(json, 'accountCode') ? undefined : json['accountCode'],
        'passengerAges': !exists(json, 'passengerAges') ? undefined : json['passengerAges'],
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(RouteFromJSON)),
    };
}

export function ShoppingDiagnosticsRequestToJSON(value?: ShoppingDiagnosticsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'channel': Int32IdAndLabelToJSON(value.channel),
        'salesJourney': value.salesJourney,
        'agency': value.agency,
        'directFlightsOnly': value.directFlightsOnly,
        'preferredCarriers': value.preferredCarriers,
        'maxConnectionTime': value.maxConnectionTime,
        'excludeBaglessFares': value.excludeBaglessFares,
        'fareTypes': value.fareTypes,
        'accountCode': value.accountCode,
        'passengerAges': value.passengerAges,
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(RouteToJSON)),
    };
}


